import { render, staticRenderFns } from "./edit-observation-modal.component.vue?vue&type=template&id=56efb4c1&scoped=true&"
import script from "./edit-observation-modal.component.vue?vue&type=script&lang=ts&"
export * from "./edit-observation-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./edit-observation-modal.component.vue?vue&type=style&index=0&id=56efb4c1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56efb4c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
